<template>
  <div class="content-contents">
    <div v-if="complaint.formDetails">
      <v-col
        v-if="complaint && complaint.complaintReport && complaint.complaintReport.stageId == 7 && complaint.complaintReport.saveReasonToComplainant"
        cols="12"
      >
        <naj-input
          :type-id="formFieldType.text"
          :value.sync="complaint.complaintReport.saveReasonToComplainant"
          :label="local.complaints.complaintDetails.closingReason"
          class="view-input"
          disabled
        ></naj-input>
      </v-col>
      <complaint-preview-tab
        :complaint-obj="complaint.formDetails"
        :show-details-mode="true"
      ></complaint-preview-tab>
      <v-col
        v-if="attachments && attachments.length>0"
        cols="12"
      >
        <naj-attachment
          view-mode
          :attachment-list="attachments"
        >
        </naj-attachment>
      </v-col>
    </div>
    <div v-else>
      <v-col
        v-if="complaint && complaint.complaintReport && complaint.complaintReport.stageId == 7 && complaint.complaintReport.saveReasonToComplainant"
        cols="12"
      >
        <naj-input
          :type-id="formFieldType.text"
          :value.sync="complaint.complaintReport.saveReasonToComplainant"
          :label="local.complaints.complaintDetails.closingReason"
          class="view-input"
          disabled
        ></naj-input>
      </v-col>
      <naj-box
        :title="local.complaints.complaintDetails.complaintUserInfo.title"
        header-icon="mdi-account"
        header-class="sub-header"
        disable-collapsing
      >
        <profile-details
          :user-object="complaint.applyComplainant"
          :is-profile="false"
          :show-modify-mobile="false"
        ></profile-details>
      </naj-box>
      <case-details :complaint="complaint"></case-details>
      <naj-box
        :title="local.complaints.complaintDetails.complaintInfo"
        header-icon="mdi-format-list-bulleted-square"
        header-class="sub-header"
        disable-collapsing
      >
        <v-col cols="12">
          <naj-input
            :type-id="formFieldType.textarea"
            :value.sync="complaint.details"
            :label="local.complaints.complaintDetails.complaintInfo"
            disabled
          ></naj-input>
        </v-col>
        <v-col
          v-if="complaint.demands"
          cols="12"
        >
          <naj-input
            :type-id="formFieldType.text"
            :value.sync="complaint.demands"
            :label="local.complaints.complaintDetails.requestLogInfo.requests"
            class="view-input"
            disabled
          ></naj-input>
        </v-col>
        <v-col
          v-if="attachments && attachments.length>0"
          cols="12"
        >
          <naj-attachment
            view-mode
            :attachment-list="attachments"
          >
          </naj-attachment>
        </v-col>
      </naj-box>
    </div>
    <request-details
      v-if="complaint &&
        (complaint.showReopenRequestButton || complaint.showAddNoteRequestButton ||
          (complaint.onlineComplaintRequests && complaint.onlineComplaintRequests.length > 0)
          || (complaint.clarificationRequestList && complaint.clarificationRequestList.length > 0))"
      :complaint="complaint"
    ></request-details>
  </div>
</template>

<script>
import CaseDetails from './case-details.vue';
import RequestDetails from './request-details.vue';
import ProfileDetails from '../profile/profile-details.vue';
import ComplaintPreviewTab from '../new-complaint/complaintPreviewTab.vue';

export default {
  name: 'ComplaintDetails',
  components: {
    ProfileDetails,
    CaseDetails,
    RequestDetails,
    ComplaintPreviewTab,
  },
  props: {
    complaint: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {
    attachments() {
      if (this.complaint)
        return [].concat(this.complaint.taqadhiAttachmentList || [], this.complaint.attachmentList || [])
          .map((a) => {
            if (a)
              return {
                ...a,
                fileName: a.fileName ? a.fileName : this.local.complaints.complaintDetails.requestLogInfo.attachmentFileName,
                complaintNo: this.complaint.complaintNo,
              };
          });
      else
        return null;
    },
  },
  mounted() { },
  methods: {},
};
</script>
<style lang="scss" scoped>
</style>
